/* File: index.js
 * Path: ananunadm/src/index.js
*/
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

const root = createRoot(document.getElementById("wrapper"));
root.render(<App />);
